import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { ChurchApplication} from 'src/app/Models/applications.interface';
import { AngularFireDatabase } from '@angular/fire/database';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { Subject } from 'rxjs';
import { UserManager } from 'src/app/Services/UserManager/user-manager';


@Component({
  selector: 'app-church-applications',
  templateUrl: './church-applications.component.html',
  styleUrls: ['../volunteer/volunteer.component.scss', 'church-applications.component.css']
})
export class ChurchApplicationsComponent implements OnInit, OnDestroy {
  @Input() superAdmin: boolean;
  applications: ChurchApplication[];
  leaving = new Subject()
  id;
  uid;
  approved;
  constructor(
    private route: ActivatedRoute,
    private db: AngularFireDatabase,
    private um: UserManager
    ) { 
      this.um.getProfileSubject()
      .takeUntil(this.leaving)
      .subscribe(profile => {
        if(!profile){ return }
        this.uid = profile ? profile.uid : null
        if(this.uid){
          this.um.hideLoginContainer()
          this.checkUID()
        } else {
          this.um.openLogin()
        }
      })
  }
  ngAfterViewInit(){
    const id = this.route.snapshot.paramMap.get('id')
    this.id = id

    if(this.id){
      this.db.object(`ChurchApplications/${this.id}/approved`)
      .valueChanges()
      .takeUntil(this.leaving)
      .subscribe(approved => {this.approved = approved})
    }

  }

  checkUID = () => {
    this.db.object(`Admins/${this.uid}`)
    .valueChanges()
    .take(1)
    .subscribe(access => {
        if(access){
          this.getRecord()
        }
    })
  }
  getRecord = () => {

    if(this.superAdmin){
      this.db.list<ChurchApplication>('ChurchApplications', ref =>  ref.orderByKey()).snapshotChanges()
      .takeUntil(this.leaving)
      .subscribe(changes => {
        let apps = []
        changes.forEach(snap => {
          let app = {id: snap.key, ...snap.payload.val()}
          apps.push(app)
        })
        this.applications = apps
      })
    } else {
      if(this.id){
        this.db.list<ChurchApplication>('ChurchApplications', ref =>  ref.orderByKey().equalTo(this.id)).valueChanges()
        .takeUntil(this.leaving)
        .subscribe(apps => this.applications = apps)
      }

    }

  }

  ngOnDestroy():void {
    this.leaving.next(null)
  }

  ngOnInit(): void {
  }


  approve = (id: string | number | null = null) => {
    if(!id){
      id = this.id
      if(!this.id){
        return
      }
    }
    try{
      this.db.object(`ChurchApplications/${id}/approved`).set(true)
    } catch(e) {
      console.error(e)
    }
    
  }

  deny = (id: string | number | null = null) => {
    if(!id){
      id = this.id
      if(!this.id){
        return
      }
    }
    try{
      this.db.object(`ChurchApplications/${id}/approved`).remove()
    } catch(e) {
      console.error(e)
    }
    
  }
}
